// extracted by mini-css-extract-plugin
module.exports = {"step7H5":"Step7_step7H5__Ba9Cf","shoppingcart":"Step7_shoppingcart__pFTO0"};